<div class="sh-page-template__main__wrapper">
    <div class="sh-page-template__main__content">
        <div class="sh-master-details-content-template">
            <div class="sh-master-details-content-template__master-content -sh-no-top-spacing">
                <div class="side-by-side">
                    <div class="list sh-template-stack">
                        <sh-page-header class="sh-template-stack__item -sh-is-page-header" [title]="'reports.title' | translate"></sh-page-header>

                        <digihaven-table-header class="sh-template-stack__item" [title]="tableHeaderWithCount$ | async"></digihaven-table-header>

                        <digihaven-hierarchical-list
                            class="sh-template-stack__item"
                            [rows]="rows$ | async"
                            [columns]="columns$ | async"
                            [isLoading]="loading$ | async"
                            [hasError]="error$ | async"
                            [enableSelect]="false"
                            [hasRowActions]="false"
                        ></digihaven-hierarchical-list>

                        <sh-pagination
                            class="sh-template-stack__item"
                            [paginationInfo]="paginationInfo$ | async"
                            [previousPageMsg]="'components.pagination.previous' | translate"
                            [nextPageMsg]="'components.pagination.next' | translate"
                            [perPageMsg]="'components.pagination.per-page' | translate"
                            [scrollRef]="paginationScrollRef"
                            (paginationInfoChanged)="paginationInfoChanged($event)"
                        ></sh-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
